export default {
  '.absolute-justify-center': {
    '@apply absolute left-1/2 -translate-x-1/2': {},
  },
  '.absolute-items-center': {
    '@apply absolute top-1/2 -translate-y-1/2': {},
  },
  '.absolute-center': {
    '@apply absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2': {},
  },
  '.line-center': {
    '@apply inline-block align-middle': {},
  },
};
